import { HTTPError } from "ky";
import React from "react";
import { Login } from "./Login";

type ErrorProps = {
  fallback: (message: string) => React.ReactNode;
  children: React.ReactNode;
};

type ErrorState = {
  message: string;
  needLogin: false;
};

const shouldNeedLogin = (error: Error) =>
  error instanceof HTTPError && error.response.status === 401;

export class ErrorBoundary extends React.Component<ErrorProps, ErrorState> {
  constructor(props: any) {
    super(props);
    this.state = { message: "", needLogin: false };
  }

  static getDerivedStateFromError(error: Error) {
    const needLogin = shouldNeedLogin(error);

    if (!needLogin) {
      console.error("Derived", error);
    }
    return { message: error.message, needLogin };
  }

  componentDidCatch(error: Error, info: any) {
    if (!shouldNeedLogin(error)) {
      console.error("ErrorBoundary", { error }, { info });
    }
  }

  render() {
    if (this.state.needLogin) {
      return <Login />;
    }
    if (this.state.message) {
      // You can render any custom fallback UI
      return this.props.fallback(this.state.message);
    }

    return this.props.children;
  }
}
